import React from 'react';
//import { styled } from '@mui/material/styles';
import {Menu, MenuItem, IconButton, Grid, Typography, Divider } from '@mui/material';
import { useNavigate  } from "react-router-dom";
import withRouter from '../../../helpers/withRouter';
import {signOutFromApp} from "../../../helpers";
import PasswordDialog from "./PasswordDialog";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Avatar from '@mui/material/Avatar';
import { Box, ThemeProvider, createTheme } from '@mui/system';
//import NotificationStyles from '../../../styles/jss/components/NotificationStyles';
import { fetchUserAttributes } from 'aws-amplify/auth';

const UserOptions = (props) => {

    //const theme = createTheme(NotificationStyles);
    const navigate = useNavigate();

    const StyledMenu = ((props) => (
      <Menu
        // getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...props}
      />
    ));

    // Password Dialog
    const [open, setOpen] = React.useState(false);
    const openDialog = () => setOpen(true);
    const closeDialog = () => setOpen(false);

    // Menu handler
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    // Initials
    const [userInitials, setUserInitials] = React.useState('');

    React.useEffect(() => {
      fetchUserAttributes()
        .then((attributes) => setUserInitials(attributes.email.charAt(0).toUpperCase()))
        .catch((e) => console.log(e));
    }, []);

    const handleClose = (action) => {
        switch(action) {
            // case 'profile':
            //     props.history.push('/profile');
            //     setAnchorEl(null);
            //     break;
            case 'password':
                openDialog()
                setAnchorEl(null);
                break;
            default:
                setAnchorEl(null);
        }
    };

    return (
        <Box>
            <PasswordDialog open={open} closeDialog={closeDialog} />
            <IconButton size="small"
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={(e) => handleClick(e)}
            >
              <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  <MoreVertIcon />
              </Box>
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Avatar sx={{
                    color: '#fff',
                    backgroundColor: '#303030',
                  }}>{userInitials}</Avatar>
              </Box>
            </IconButton>
            <StyledMenu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                classes={{}}>
              <Grid container spacing={0}>
                <Grid size={{ xs: 9 }} >
                    <Typography variant="subtitle1" sx={{
                      padding: 2,
                      width:'480px',
                      fontSize: '16px',
                      fontWeight: 'bold'
                    }}>{props.org.name}</Typography>
                </Grid>
              </Grid>
              <Divider />
              <MenuItem sx={{ padding: 2 }} onClick={() => handleClose('password')}>Change Password</MenuItem>
              <MenuItem sx={{ padding: 2 }} onClick={() => signOutFromApp(navigate)}>Sign Out</MenuItem>
            </StyledMenu>
          </Box>
    );
}

export default withRouter(UserOptions);